/**
 * Define the constants used in the API component
 * @type {string}
 */
export const REQUEST_STARTED = 'REQUEST_STARTED';
export const REQUEST_SUCCESSFUL = 'REQUEST_SUCCESSFUL';
export const REQUEST_FAILED = 'REQUEST_FAILED';
export const RESET_REQUEST = 'RESET_REQUEST';

/**
 * Define the requestStarted constant
 * @returns {{data: null, type: string}}
 */
export const requestStarted = () => ({
    type: REQUEST_STARTED,
    data: null,
});

/**
 * Define the requestSuccessful constant
 * @param data
 * @returns {{data, type: string}}
 */
export const requestSuccessful = ({data}) => ({
    type: REQUEST_SUCCESSFUL,
    data,
});

/**
 * Define the requestFailed constant
 * @param data
 * @returns {{data, type: string}}
 */
export const requestFailed = ({data}) => ({
    type: REQUEST_FAILED,
    data,
});

/**
 * Define the resetRequest constant
 * @param data
 * @returns {{data, type: string}}
 */
export const resetRequest = ({data}) => ({
    type: RESET_REQUEST,
    data,
});